// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SmileTwoToneSvg from "@fishx/icons-svg/es/asn/SmileTwoTone";
import FishxIcon from '../components/FishxIcon';

var SmileTwoTone = function SmileTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SmileTwoToneSvg
  }));
};

SmileTwoTone.displayName = 'SmileTwoTone';
export default React.forwardRef(SmileTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SmileTwoTone.js
// module id = 4162
// module chunks = 0